import { Box, styled } from "@mui/material";

const MainContainer = styled(Box)({
    display: "flex",
    flexDirection: "column",
    flex: 1,
    overflowY: "scroll",
    textAlign: "center",
    paddingBottom: "7rem",
});

export default MainContainer;
